import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from './Services/MasterDataService';
import { NgbModal, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Interval, DateTime } from 'luxon';
import { QrCodeService } from './Services/QrCodeService';
import { APIServiceConnector } from './Services/APIServiceConnector';
import { AppSettings } from './Library/AppSettings';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }]
})
export class AppComponent {
    @ViewChild('content') content;
    title = 'app';
    languageCode: string = 'en';
    ModalRef: NgbModalRef;
    dayObj = {};

    constructor(translate: TranslateService, public master: MasterDataService, public modalService: NgbModal
        , public qrCodeService: QrCodeService, public apiService: APIServiceConnector,public router: Router
        ) {
        //angulartics2GoogleTagManager.startTracking();

        // this language will be used as a fallback when a translation isn't found in the current language
        this.languageCode = "ENG";
        if(master.Cache_PropertyMainMasters.getValue(master.ActivePropertyID) && master.Cache_PropertyMainMasters.getValue(master.ActivePropertyID).LanguageCode){
            this.languageCode = master.Cache_PropertyMainMasters.getValue(master.ActivePropertyID).LanguageCode;
        }

       translate.setDefaultLang(this.languageCode);

    // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use(this.languageCode);
    }

    ngOnInit() {
        if (!AppSettings.EnableUnifocusSSO) {
            setTimeout(() => {
                this.checkForPasswordExpiry()
            });
        }
        this.qrCodeService.redirectToHome.subscribe((data)=>{
            if(!data){
                this.router.navigateByUrl('');
            }
            else{
                this.router.navigateByUrl('home/Calls/JobConsole');
            }
        });
    }

    ngAfterViewInit() {
        document.body.style.background = 'none';
    }

    private checkForPasswordExpiry() {
        const currentUser = this.master.LoggedInUserData;
        const dt = DateTime.fromISO('1900-01-01T00:00:00Z');
        const expiryDate = currentUser.PasswordExpiryDate && DateTime.fromISO('' + currentUser.PasswordExpiryDate);
        if (expiryDate && !expiryDate.equals(dt)) {
            const interval = Interval.fromDateTimes(
                DateTime.local(),
                DateTime.fromISO('' + currentUser.PasswordExpiryDate)
            );
            const days = interval && interval.toDuration('days').toObject().days;
            this.dayObj = {
                daysLeft: Math.ceil(days)
            }
            if (days && days <= currentUser.PwdPromptDays) {
                let ngbModalOptions: NgbModalOptions = {
                    backdrop : 'static',
                    centered: true
                };
                this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
            }

        }
    }
}
